exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".progress-container{display:flex;flex-direction:column;justify-content:space-evenly;padding-inline:10px;padding-block:5px;height:45px;background:#315f75;width:200px;border-radius:3px;font-size:12px}.progress-container .progress-bar{background:#294858;border-radius:3px;width:100%;height:6px}.progress-container .progress-bar .inner-bar{background:#7fb3cb;border-radius:2px;height:6px;transition:.5s ease-in}@media(max-width:992px){.progress-container{width:155px}}", ""]);

// exports
